// extracted by mini-css-extract-plugin
module.exports = {"containerOuter":"ContainerOuter_containerOuter__KGgBn"};